export default "__VITE_ASSET__as_ChN$F__"